import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListDimensionNodeRequest extends IBaseRequest {
    limit?:           string;
    offset?:          string;
    orderBy?:         string;
    treeHandle?:      string;
    id?:              string;
    systemId?:        string;
    rootAndChildren?: string;
    refId?:           string;
}

export class ListDimensionNodeRequest extends BaseRequest implements IListDimensionNodeRequest {

    public limit?:           string;
    public offset?:          string;
    public orderBy?:         string;
    public treeHandle?:      string;
    public id?:              string;
    public systemId?:        string;
    public rootAndChildren?: string;
    public refId?:           string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.limit           = otherOptions.limit;
        this.offset          = otherOptions.offset;
        this.orderBy         = otherOptions.orderBy;
        this.treeHandle      = otherOptions.treeHandle;
        this.id              = otherOptions.id;
        this.systemId        = otherOptions.systemId;
        this.rootAndChildren = otherOptions.rootAndChildren;
        this.refId           = otherOptions.refId;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.systemId, 'systemId');
        parameters += this.makeNode(this.rootAndChildren, 'rootAndChildren');
        parameters += this.makeNode(this.refId, 'refId');
        
        return super.wrapperXml('ListDimensionNode', parameters);
    }
}
